import { ButtonV2, styled } from '@withjoy/joykit';

export const StyledEventFormButton = styled(ButtonV2)``;
export const StyledEventBackButton = styled(ButtonV2)``;
